import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { WATERMARK_MARGIN } from '../../../constants'
import CreationToolWatermarkPosition from '../../../types/watermark'
import { CreationToolsArtboardContext } from './../context'
import Draggable from '../draggable'
import { ArtboardCornerPosition, ArtboardDragPosition } from '../types'

const Watermark = styled.img`
    width: 100%;
`

type Props = {
    position: CreationToolWatermarkPosition
    forceSelected?: boolean
    width: number
    source: string
    onUpdate?: (width: number) => void
}

const getArtboardCornerFromPosition = (position: CreationToolWatermarkPosition): ArtboardCornerPosition => {
    switch (position) {
        case CreationToolWatermarkPosition.BottomLeft:
            return ArtboardCornerPosition.BottomLeft
        case CreationToolWatermarkPosition.BottomRight:
            return ArtboardCornerPosition.BottomRight
        case CreationToolWatermarkPosition.TopLeft:
            return ArtboardCornerPosition.TopLeft
        case CreationToolWatermarkPosition.TopRight:
            return ArtboardCornerPosition.TopRight
    }
}

const CreationToolsArtboardCropLayer = ({ forceSelected, position, source, width, onUpdate }: Props) => {
    const { canvasScale, renderingContext } = useContext(CreationToolsArtboardContext)
    const [imgWidth, setImgWidth] = useState<number>(0)
    const [imgHeight, setImgHeight] = useState<number>(0)
    const transformOrigin = getArtboardCornerFromPosition(position)
    const artboardWidth = (renderingContext?.canvas.width || 0) / canvasScale
    const artboardHeight = (renderingContext?.canvas.height || 0) / canvasScale
    const margin = artboardWidth * WATERMARK_MARGIN
    const x = transformOrigin.indexOf('right') > -1 ? artboardWidth - margin : margin
    const y = transformOrigin.indexOf('bottom') > -1 ? artboardHeight - margin : margin

    useEffect(() => {
        const img = document.createElement('img')
        img.onload = () => {
            setImgWidth(img.naturalWidth)
            setImgHeight(img.naturalHeight)
        }
        img.crossOrigin = 'anonymous'
        img.src = source
    }, [source, setImgWidth, setImgHeight])

    const onDragUpdate = ({ scaleX }: ArtboardDragPosition) => {
        onUpdate && onUpdate(Math.round(width * scaleX * canvasScale))
    }

    if (!imgWidth || !imgHeight) {
        return null
    }

    return (
        <Draggable
            key={`watermarklayer-${position}`}
            {...{
                defaultX: x,
                defaultY: y,
                height: width / (imgWidth / imgHeight),
                lockAspectRatio: true,
                resizeable: true,
                onUpdate: onDragUpdate,
                width,
                forceSelected,
                transformOrigin,
            }}
        >
            <Watermark src={source} alt="" />
        </Draggable>
    )
}

export default CreationToolsArtboardCropLayer
